// extracted by mini-css-extract-plugin
export default {"confirm":"ClosablePopup_confirm__rhZJ0","body":"ClosablePopup_body__NU3d5"};